import { AlertTriangle, Coffee } from "lucide-react";

/**
 * Room-wide status banner shown when the host is either on a scheduled
 * BRB break or has hit the AFK auto-end warning. Pure presentational.
 */
export default function LiveRoomAfkBanner({ afk }) {
  if (!afk?.brb_active && !afk?.afk_warning) return null;
  return (
    <div
      className={`absolute left-1/2 -translate-x-1/2 top-16 z-40 rounded-full px-4 py-2 text-sm font-medium backdrop-blur-md border flex items-center gap-2 shadow-lg ${
        afk.brb_active
          ? "bg-amber-500/25 border-amber-300/60 text-amber-100"
          : "bg-rose-600/30 border-rose-300/60 text-rose-100"
      }`}
      data-testid={afk.brb_active ? "afk-banner-brb" : "afk-banner-warning"}
    >
      {afk.brb_active ? <Coffee size={14} /> : <AlertTriangle size={14} />}
      <span className="whitespace-nowrap">
        {afk.brb_active
          ? `Host is on a quick break${
              afk.brb_seconds_left != null
                ? ` · ${Math.floor(afk.brb_seconds_left / 60)}:${String(afk.brb_seconds_left % 60).padStart(2, "0")} left`
                : ""
            }`
          : `Host stepped away — ending in ${afk.afk_seconds_left ?? 30}s`}
      </span>
    </div>
  );
}
